import { Component } from '@angular/core';

@Component({
  selector: 'opac-table-cell-header',
  templateUrl: './table-cell-header.component.html',
  styleUrls: ['./table-cell-header.component.scss']
})
export class TableCellHeaderComponent {
}
